import React, { useState } from 'react'
import { HelpItems } from './Help.constant'
import { HelpStyled } from './Help.style'

export default function HelpSide() {
    const [open, setOpen] = useState(false)

    const changeStatus = (id) => {
        HelpItems.map((item) => (item.id === id) ? ((item.status === true)
         ? item.status = false : item.status = true) : "")
        setOpen(p => !p)
    }

    return (
        <HelpStyled>
            <div className='help-main'>
                <div className='redline'><span></span>Frequently Asked Questions</div>

                <div className='help-list'>
                    {
                        HelpItems.map((item) => (
                            <div className='help-item'>
                                <div className='help-top'>
                                    <h3>{item.title}</h3>
                                    <span
                                        className={item.status === true ? "active" : ""}
                                        onClick={() => changeStatus(item.id)}
                                    >+</span>
                                </div>
                                {
                                    (item.status === true) && <p className='help-text' style={{fontSize:"20px", margin: "12px"}} >{item.text}</p>
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </HelpStyled>
    )
}
